import { render, staticRenderFns } from "./MaintenanceInputwrap.vue?vue&type=template&id=e0806974&"
import script from "./MaintenanceInputwrap.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceInputwrap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports